<script lang="ts" setup>
import { Popup } from "vant";
import { useRouteQuery } from "@vueuse/router";
import { ref, watch } from "vue";
import { useGlobalUser } from "@/stores/globalUser";
import { storeToRefs } from "pinia";
import { redeemDiscordGift } from "@/apis/user";
import { useRouter } from "vue-router";

const userStore = useGlobalUser();
const { isLogin } = storeToRefs(userStore);

const redeemCode = useRouteQuery("redeemCode", "");
const show = ref(false);
const isLoading = ref(false);
const router = useRouter();

const clearRedeemCode = () => {
  router.replace({
    query: { ...router.currentRoute.value.query, redeemCode: undefined },
  });
};

watch(
  [redeemCode, isLogin],
  async () => {
    if (!redeemCode.value || userStore.hasRedeemedGift) {
      clearRedeemCode();
      show.value = false;
      return;
    }
    if (!isLogin.value) {
      userStore.loginModal.show = true;
      return;
    }
    show.value = true;
    isLoading.value = true;
    try {
      await redeemDiscordGift(redeemCode.value);
      await userStore.refreshUser();
      isLoading.value = false;
    } catch (e) {
      show.value = false;
      clearRedeemCode();
    }
  },
  { immediate: true }
);
const closeAndReplace = () => {
  show.value = false;
  clearRedeemCode();
};
</script>
<template>
  <Popup
    v-model:show="show"
    :closeOnClickOverlay="false"
    class="flex bg-base-100 max-w-[80%]"
    round
  >
    <div class="w-full relative">
      <div
        v-if="isLoading"
        class="flex items-center justify-center flex-col gap-4 p-4 py-8 lg:p-8"
      >
        <span class="loading"></span>
        <div>Checking</div>
      </div>
      <div v-else class="flex flex-col items-center justify-center">
        <div
          :style="{
            backgroundImage: 'url(/img/gift-redeem.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backdropFilter: 'blur(10px)',
          }"
          class="w-full flex items-center justify-center h-48 relative backdrop-blur"
        >
          <div class="absolute inset-0 backdrop-blur-sm"></div>
          <img
            alt="gift-redeem pointer-events-none"
            class="h-48 rounded relative z-10"
            src="/img/gift-redeem.webp"
          />
        </div>
        <div class="flex flex-col items-center justify-center p-4 gap-4">
          <div class="flex flex-col items-center justify-center gap-2">
            <span class="font-bold text-base"
              >🎉 {{ $t("Message.congratulations") }} 🎉
            </span>
            <span class="text-center">
              {{ $t("Message.redeemSuccessTip") }}
            </span>
          </div>
          <div class="justify-end">
            <button class="btn btn-sm btn-primary" @click="closeAndReplace">
              👍 {{ $t("Buttons.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <template #overlay-content>
      <Confetti v-if="!isLoading" />
    </template>
  </Popup>
</template>
